import React, { useEffect, useState } from "react";
import loaderGif from '@assets/gifs/loader.gif'
import styles from "./Loader.module.css";

function Loader() {
  

  return (
    <div
      className={`${styles.modal} `}
    >
      <div
        className={`${styles.modalContent}`}
        onClick={(e) => e.stopPropagation()}
      >
        <img src={loaderGif} alt="Loading..." />
      </div>
    </div>
  );
}

export default Loader;
